import { Popover } from "antd";
import { PrimaryButton } from "components/Button/ActionButton";
import { useAuth } from "hooks/useAuth";
import type { FC } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { AppDivider, AppLink, ContentWrapper, OpenButtonMenu } from "./userProfileStyles";

export type UserProfileProps = {
    apps: string[];
    switchApp: (_: string) => void;
};

export const UserProfile: FC<UserProfileProps> = ({ apps, switchApp }: UserProfileProps) => {
    const { signOut } = useAuth();
    const navigate = useNavigate();

    const handleSignOut = useCallback(() => {
        signOut();
        navigate("/auth");
    }, [signOut, navigate]);

    const otherApps = apps.map((app) => (
        <AppLink key={`key_${app}`} type="button" onClick={() => switchApp(app)}>
            {app}
        </AppLink>
    ));

    const content = (
        <ContentWrapper>
            {otherApps}
            <AppDivider />
            <PrimaryButton onClick={handleSignOut} data-name="sign_out_button">
                Sign Out
            </PrimaryButton>
        </ContentWrapper>
    );

    return (
        <Popover content={content} trigger="click" placement="bottomRight">
            <OpenButtonMenu role="button">&#8942;</OpenButtonMenu>
        </Popover>
    );
};
